import { Navigate } from "react-router";
import { useAuth } from "@/lib/session/auth-context";

/**
 * The app's root has no page of its own - the pitch lives on the website (web/, prestobooks.at).
 * Signed in it goes to the dashboard, signed out to the login.
 */
export function RootRedirect() {
  const { isAuthenticated, loading } = useAuth();
  if (loading) return null;
  return <Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />;
}
